<template lang="html">
  <div class="tab-bar">
    <b-link
      class="tab"
      data-text="Destroy"
      @click="showConfirmDestroyModal()"
      v-if="capsule.status !== 'published'"
    >
      <span class="icon"><i class="pe-7s-trash"></i></span>
    </b-link>
    <b-link class="tab" data-text="Duplicate" @click="duplicate()">
      <span class="icon"><i class="pe-7s-copy-file"></i></span>
    </b-link>
    <router-link
      class="tab"
      data-text="View"
      :to="{ name: 'ShowCapsule', params: { capsuleId: capsule.id } }"
    >
      <span class="icon"><i class="pe-7s-look"></i></span>
    </router-link>
    <router-link
      class="tab"
      data-text="Edit"
      :to="{ name: 'CapsuleBuilder', params: { capsuleId: capsule.id } }"
    >
      <span class="icon"><i class="pe-7s-note"></i></span>
    </router-link>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  props: {
    capsule: {
      type: Object,
    },
  },

  methods: {
    ...mapActions(["duplicateCapsule"]),

    showConfirmDestroyModal() {
      this.$nextTick(() => {
        this.$modal.show("confirm-destroy-capsule", {
          capsuleId: this.capsule.id,
        });
      });
    },

    duplicate() {
      this.duplicateCapsule({ capsuleId: this.capsule.id }).then(() => {
        bus.$emit("makeToast", "Success! 🎉", `Capsule duplicated`, "success");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

$font-size: 12px;
$time: 0.3s;
$border: 1px;
$border-radius: 5px;
$border-color: #5fef8d;
$chip-color: $primary-accent;
$morph-chip-color: $primary-blue;
$selected-bg: rgba(0, 0, 0, 0.1);

@mixin border() {
  border: $border solid $border-color;
  border-right: none;
  &:last-child {
    border-right: $border solid $border-color;
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
  }
  &:first-child {
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
  }
}
.radius {
  border-radius: $border-radius;

  .tab:active::before {
    border-radius: $border-radius !important;
  }
}

.border .tab {
  @include border();
  &:active::before {
    border-radius: inherit !important;
  }
}

.tab-bar {
  // background-color: coral;
  // box-shadow: 1px 4px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  margin: 0;
  margin-top: -20px;
  // color: black;
  color: $grey3;
  justify-content: flex-end;
  overflow-x: visible;

  .tab {
    box-sizing: border-box;
    text-decoration: none;
    color: inherit;
    width: 45px;
    height: 70px;
    background: inherit;
    padding: 5px;
    display: inherit;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all $time;

    &::before {
      position: absolute;
      content: "";
      width: 26%;
      height: 13%;
      border-top-left-radius: 200px;
      border-top-right-radius: 200px;
      border-bottom: none;
      background-color: $chip-color;
      bottom: -8px;
      opacity: 0;
      transition: all $time ease-in-out;
    }

    // &:active::before {
    //   width: 100%;
    //   height: 100%;
    //   background-color: $morph-chip-color;
    //   border-radius: 0;
    // }

    &:hover::before {
      opacity: 1;
      bottom: 0px;
    }

    &::after {
      content: attr(data-text);
      position: absolute;
      top: 0;
      width: 100%;
      text-align: center;
      color: inherit;
      // color: $primary-blue;
      font-size: $font-size;
      opacity: 0;
      transition: all $time ease-in-out;
    }

    &:hover {
      &::after {
        opacity: 1;
        top: 6px;
      }
      padding-top: 15px;
    }

    &.selected {
      background-color: $selected-bg;
      border-radius: inherit;

      &::after {
        opacity: 1;
        top: 6px;
      }
      &::before {
        opacity: 1;
        bottom: 0px;
      }
      padding-top: 15px;
    }

    .icon {
      color: inherit;
      z-index: 10;
      font-size: 2 * $font-size;
      display: inherit;

      img,
      i {
        margin: auto;
        height: 2 * $font-size;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tailor/Actions.vue